import request from "@/utils/request.js";
const baseURL = '/order'
const proxy = '/deposit'
const api = {

    tzdH5: (params) => {
        return request({
            url: proxy + `/api/wxzjjctzd/tzdH5`,
            method: "get",
            params
        });
    },
    // 创建通知单订单 农行
    crateOrderById: (id) => {
        return request({
            method: 'get',
            url: baseURL + '/api/wxzjqworder/createOrder/' + id,
        })
    },

    // 发送邮箱
    sendemail: (params) => {
        return request({
            method: 'get',
            url: proxy + '/api/wxzjjctzd/sendemail',
            params
        })
    },

}
export default api

